<template>
  <div class="bg-white dark:bg-[#1C2128] border-b border-gray-100 dark:border-gray-700">
    <div class="flex items-center px-4 sm:px-6 pt-4 pb-2">
      <router-link to="/events" data-turbo-prefetch="false"
        class="mr-4 p-2 border border-gray-200 fill-blue-600 hover:bg-blue-50 rounded-full inline-flex dark:border-gray-600 dark:fill-white dark:hover:bg-gray-700">
        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
        </svg>
      </router-link>
      <span class="w-7 h-7 rounded-full flex-shrink-0 mr-2.5" :class="event.color"></span>
      <span class="font-semibold text-gray-900 dark:text-white truncate">{{ event.name }}</span>
    </div>

    <ul class="flex overflow-x-auto no-scrollbar text-sm px-4 sm:px-6">
      <li v-for="tab in tabs" :key="tab.key" class="mr-2">
        <router-link v-if="tab.routed" :to="tab.path" data-turbo="false"
          class="inline-block px-3 py-3.5 whitespace-nowrap border-b-[3px] transition-colors"
          :class="currentTab === tab.key
            ? 'border-blue-600 text-gray-900 dark:text-white font-semibold'
            : 'border-transparent text-gray-500 hover:text-gray-900 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-100'">
          {{ tab.label }}
        </router-link>
        <a v-else :href="tab.path" data-turbo="false"
          class="inline-block px-3 py-3.5 whitespace-nowrap border-b-[3px] transition-colors"
          :class="currentTab === tab.key
            ? 'border-blue-600 text-gray-900 dark:text-white font-semibold'
            : 'border-transparent text-gray-500 hover:text-gray-900 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-100'">
          {{ tab.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useConstants } from 'composables/useConstants.js'

const props = defineProps({
  event: { type: Object, required: true },
  currentTab: { type: String, required: true },
})

const { I18N } = useConstants()

const tabs = computed(() => [
  { key: 'bookings',     label: I18N.application.index.bookings,                         path: `/events/${props.event.id}/bookings`,     routed: true },
  { key: 'attendees',   label: I18N.website_content.app_nav.attendees,                  path: `/events/${props.event.id}/attendees`,   routed: true },
  { key: 'analytics',   label: I18N.website_content.app_nav.analytics,                  path: `/events/${props.event.id}/analytics`,   routed: true },
  { key: 'qr_code',     label: I18N.website_content.account_settings.qr_code.title,     path: `/events/${props.event.id}/qr_code`,     routed: true },
  { key: 'embed',       label: I18N.website_content.account_settings.embed.title,       path: `/events/${props.event.id}/embed`,       routed: true },
  { key: 'link_button', label: I18N.website_content.account_settings.link_button,       path: `/events/${props.event.id}/link_button`, routed: true },
])
</script>
